import React, { useEffect, useContext, useRef } from 'react';
import { AppContext } from '../../../../context/Context';
import { useTranslation } from 'react-i18next';
import '../../../../assets/css/buttons.css';
import { SocketContext } from '../../../../context/SocketContext';
import toast from 'react-hot-toast';
import {
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
} from '@mui/icons-material/';
import {
  Box,
  Grid,
  Typography,
  Button,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';

function ModalPapirTicketNotSold() {
  const { t } = useTranslation();

  const {
    updateFocusOnMainScreen,
    updateShowModalPapirTicketNotSold,
    updatePapirScannedInfo,
    papirScannedInfo,
  } = useContext(AppContext);

  const papirScannedInfoRef = useRef(papirScannedInfo);
  useEffect(() => {
    papirScannedInfoRef.current = papirScannedInfo;
  }, [papirScannedInfo]);

  //* DISABLE FOCUS ON MAIN SCREEN AND PREVENT ESCAPE BUTTON
  useEffect(() => {
    updateFocusOnMainScreen(false);

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  //* SOCKET SETUP
  const { socket } = useContext(SocketContext);

  useEffect(() => {}, [socket]);

  //* CONFIRM REGISTRATION BUTTON (search if phone exist or register the user)
  const confirmClose = async () => {
    updatePapirScannedInfo(false);
    updateFocusOnMainScreen(true);
    updateShowModalPapirTicketNotSold(false);
  };

  return (
    <div id="react-confirm-alert">
      <div
        className="react-confirm-alert-overlay"
        style={{
          background: 'rgba(3,6,18,0.88)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div
          style={{
            width: 'min(1000px, 94vw)',
            borderRadius: '24px',
            overflow: 'hidden',
            border: '1px solid rgba(255,255,255,0.12)',
            boxShadow: '0 30px 90px rgba(0,0,0,0.65)',
            backdropFilter: 'blur(14px)',
            WebkitBackdropFilter: 'blur(14px)',
            background:
              'linear-gradient(135deg, rgba(18,26,55,0.98), rgba(10,14,28,0.98))',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {/* Header */}
          <Box
            sx={{
              height: 70,
              px: '24px',
              display: 'flex',
              alignItems: 'center',
              borderBottom: '1px solid rgba(255,255,255,0.10)',
              background:
                'linear-gradient(135deg, rgba(255,255,255,0.06), rgba(255,255,255,0.02))',
              flexShrink: 0,
            }}
          >
            <Typography
              sx={{ color: 'white', fontSize: '24px', fontWeight: 900, lineHeight: 1 }}
            >
              {t('sales.papirTicketNotSoldTitle')}
            </Typography>
          </Box>

          {/* Body */}
          <Box sx={{ p: '24px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <Box
              sx={{
                borderRadius: '18px',
                border: '1px solid rgba(255,255,255,0.14)',
                background: 'rgba(255,255,255,0.06)',
                p: '24px',
                display: 'flex',
                flexDirection: 'column',
                gap: '12px',
              }}
            >
              <Typography sx={{ color: 'rgba(255,255,255,0.75)', fontSize: 22 }}>
                {t('sales.papirTicketNotSoldText1')}
              </Typography>
              {/*<Typography sx={{ color: 'rgba(255,255,255,0.75)', fontSize: 22 }}>{t('sales.papirTicketNotSoldText2')}</Typography>*/}

              {papirScannedInfoRef.current &&
                papirScannedInfoRef.current.historic.length > 0 && (
                  <>
                    <Typography sx={{ color: 'rgba(255,255,255,0.75)', fontSize: 22 }}>
                      {t('sales.papirTicketNotSoldText3')}
                    </Typography>
                    <Paper
                      sx={{
                        flexGrow: 1,
                        border: '1px solid rgba(255,255,255,0.14)',
                        bgcolor: 'rgba(255,255,255,0.04)',
                        borderRadius: 2,
                        boxShadow: 'none',
                        overflow: 'hidden',
                        display: 'flex',
                        flexDirection: 'column',
                        maxHeight: 380,
                      }}
                    >
                      <TableContainer sx={{ flexGrow: 1, overflowY: 'auto' }}>
                        <Table
                          stickyHeader
                          size="small"
                          sx={{
                            '& .MuiTableCell-root': {
                              borderColor: 'rgba(255,255,255,0.10)',
                              color: 'rgba(255,255,255,0.80)',
                              fontSize: 17,
                            },
                            '& .MuiTableCell-head': {
                              color: 'white',
                              fontWeight: 700,
                              fontSize: 17,
                              bgcolor: 'rgba(255,255,255,0.10)',
                            },
                          }}
                        >
                          <TableHead>
                            <TableRow>
                              <TableCell align="center">
                                {t('sales.papirTicketDate')}
                              </TableCell>
                              <TableCell align="center">
                                {t('sales.papirTicketGameID')}
                              </TableCell>
                              <TableCell align="center">
                                {t('sales.papirTicketTransaction')}
                              </TableCell>
                              <TableCell align="center">
                                {t('sales.papirTicketAmount')}
                              </TableCell>
                              <TableCell align="center">
                                {t('sales.papirTicketPrizes')}
                              </TableCell>
                              <TableCell align="center">
                                {t('sales.papirTicketPrizesPayout')}
                              </TableCell>
                            </TableRow>
                          </TableHead>

                          <TableBody>
                            {papirScannedInfoRef.current.historic.length > 0 &&
                              papirScannedInfoRef.current.historic.map(
                                (ticket, i) => (
                                  <TableRow
                                    key={i}
                                    hover
                                    sx={{
                                      bgcolor:
                                        i % 2
                                          ? 'rgba(255,255,255,0.04)'
                                          : 'transparent',
                                      '&:hover': {
                                        bgcolor: 'rgba(255,255,255,0.08)',
                                      },
                                    }}
                                  >
                                    <TableCell align="center">
                                      {ticket.date}
                                    </TableCell>
                                    <TableCell align="center">
                                      {ticket.gameID}
                                    </TableCell>
                                    <TableCell align="center">
                                      {ticket.transID === 12
                                        ? t('sales.papirTicketSold')
                                        : ticket.transID === 11
                                          ? t('sales.papirTicketPrizes')
                                          : ticket.transID === 14
                                            ? t('sales.papirTicketCancel')
                                            : '-'}
                                    </TableCell>
                                    <TableCell align="center">
                                      {ticket.amount}
                                    </TableCell>
                                    <TableCell align="center">
                                      {ticket.prize === '' ? '-' : ticket.prize}
                                    </TableCell>
                                    <TableCell align="center">
                                      {ticket.isPayedOut ? 'V' : '-'}
                                    </TableCell>
                                  </TableRow>
                                )
                              )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Paper>
                  </>
                )}
            </Box>

            <Box sx={{ display: 'flex', gap: '14px' }}>
              <Button
                fullWidth
                variant="contained"
                onClick={() => { confirmClose(); }}
                startIcon={<CheckCircleIcon sx={{ fontSize: 28 }} />}
                sx={{
                  height: 76,
                  borderRadius: '16px',
                  bgcolor: '#FFC727',
                  color: '#000',
                  fontWeight: 800,
                  fontSize: 22,
                  textTransform: 'uppercase',
                  boxShadow: '0 12px 32px rgba(255,199,39,0.4)',
                  '&:hover': {
                    bgcolor: '#FFD54F',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 16px 40px rgba(255,199,39,0.55)',
                  },
                  '&:active': { transform: 'translateY(0)' },
                }}
              >
                {t('sales.confirm')}
              </Button>
            </Box>
          </Box>
        </div>
      </div>
    </div>
  );
}

export default ModalPapirTicketNotSold;
